import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bwc-label" }
const _hoisted_2 = ["title", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["bwc", `is-${_ctx.tone}`])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ], true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "bwc-close",
      title: _ctx.closeLabel || _ctx.$t('common.close'),
      "aria-label": _ctx.closeLabel || _ctx.$t('common.close'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove')))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "bi bi-x" }, null, -1)
    ]), 8, _hoisted_2)
  ], 2))
}